import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import sidebar from './modules/sidebar'
import page from './modules/page'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    sidebar,
    page
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js